import {
  purposeStatement,
  missionStatement,
  visionStatement,
} from "@/mocks/aboutData";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import Icon from "@/components/feature/Icon";
import { useSiteSettings } from "@/lib/siteSettings";

export default function VisionSection() {
  const { ref: headerRef, style: headerStyle } = useScrollReveal();
  const { ref: cardsRef, style: cardsStyle } = useScrollReveal({ delay: 150 });
  const { settings } = useSiteSettings();

  return (
    <section className="pt-16 pb-24 md:pt-20 md:pb-32 bg-white">
      <div className="px-6 md:px-10 lg:px-16">
        {/* Section header */}
        <div ref={headerRef} style={headerStyle} className="max-w-3xl mb-16 md:mb-20">
          <p className="text-sm font-medium tracking-[0.2em] text-navy-700 uppercase mb-4">
            Our Foundation
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-navy-950 leading-tight">
            成立宗旨與願景
          </h2>
        </div>

        {/* Three statement cards */}
        <div ref={cardsRef} style={cardsStyle} className="grid lg:grid-cols-3 gap-8 md:gap-10">
          {/* Purpose */}
          <div className="relative bg-navy-950 rounded-3xl p-8 md:p-10 border border-navy-800/50 hover:shadow-2xl hover:-translate-y-1 transition-all duration-500">
            <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center mb-8">
              <Icon className="ri-flag-line text-xl text-white" />
            </div>
            <p className="text-xs font-medium tracking-[0.2em] text-silver-400 uppercase mb-3">
              {purposeStatement.tagline}
            </p>
            <h3 className="text-xl md:text-2xl font-semibold text-white mb-4 leading-snug">
              {purposeStatement.headline}
            </h3>
            <p className="text-silver-300 text-sm md:text-base leading-relaxed">
              {purposeStatement.description}
            </p>
            <div className="mt-8 pt-6 border-t border-white/10">
              <div className="flex items-center gap-2 text-silver-400 text-sm">
                <Icon className="ri-shield-check-line" />
                <span>{settings.contact.registration}</span>
              </div>
            </div>
          </div>

          {/* Mission */}
          <div className="bg-navy-950 rounded-3xl p-8 md:p-10 border border-navy-800/50 text-white hover:shadow-2xl hover:-translate-y-1 transition-all duration-500">
            <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center mb-8">
              <Icon className="ri-focus-3-line text-xl text-white" />
            </div>
            <p className="text-xs font-medium tracking-[0.2em] text-silver-400 uppercase mb-3">
              {missionStatement.tagline}
            </p>
            <h3 className="text-xl md:text-2xl font-semibold mb-4 leading-snug">
              {missionStatement.headline}
            </h3>
            <p className="text-silver-300 text-sm md:text-base leading-relaxed">
              {missionStatement.description}
            </p>
          </div>

          {/* Vision */}
          <div className="bg-navy-950 rounded-3xl p-8 md:p-10 border border-navy-800/50 text-white hover:shadow-2xl hover:-translate-y-1 transition-all duration-500">
            <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center mb-8">
              <Icon className="ri-eye-line text-xl text-white" />
            </div>
            <p className="text-xs font-medium tracking-[0.2em] text-silver-400 uppercase mb-3">
              {visionStatement.tagline}
            </p>
            <h3 className="text-xl md:text-2xl font-semibold mb-4 leading-snug">
              {visionStatement.headline}
            </h3>
            <p className="text-silver-300 text-sm md:text-base leading-relaxed">
              {visionStatement.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}